import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionService } from './Util/Session/session.service';
import { environment } from '../environments/environment';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SiteLockServiceService {

  constructor(
    private http: HttpClient,
    private session: SessionService
  ) {
    environment.API_URL = this.session.GetUserDetails().ApiUrl;
  }

  GetAttendanceLockUnlockSite(Detail: any) {
    return this.http.post<any>(environment.API_URL + `GetAttendanceLockUnlockSite`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }))
  }

  LockUnlockSites(Detail: any) {
    return this.http.post<any>(environment.API_URL + `AttendanceLockUnlock_Process`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }))
  }

}
